import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-black py-32 overflow-hidden">
      {/* Top border */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
      
      {/* Centered glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-[#00FFD1]/10 rounded-full blur-[150px] pointer-events-none" />

      <div className="relative z-10 max-w-[1000px] mx-auto px-5 md:px-[7.6923%] text-center">
        {/* Headline */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight">
          Ready to Transform Your
          <span className="block text-[#00FFD1]">Content Production?</span>
        </h2>

        <p className="text-xl text-white/60 mt-8 max-w-2xl mx-auto leading-relaxed">
          Join the brands already using Prysh AI to create hyper-realistic video content at unprecedented speed and scale.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
          <button 
            onClick={() => navigate('/contact')}
            className="group bg-[#00FFD1] text-black px-10 py-5 text-lg font-medium hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] transition-all duration-400 flex items-center justify-center gap-3"
          >
            Request Demo
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
